import { Agent } from "../../../../interfaces/agent.interface";

export const agentAddress = (agent: Agent) =>
  agent.address || [agent.city, agent.state].filter(Boolean).join(", ");

export const filterAgents = (agents: Agent[], query: string) => {
  const term = query.trim().toLowerCase();
  if (!term) return agents;

  return agents.filter((agent) =>
    [agent.name, agent.address, agent.city, agent.state, agent.zone].some((field) =>
      (field || "").toLowerCase().includes(term)
    )
  );
};
